export default __webpack_public_path__ + "static/media/WhatsApp Image 2023-10-16 at 14.38.04.ea6f1166.jpeg";